import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Alerts from '/src/pages/resources/alerts.md';
import Tabs from './tabs/api-reference.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "edge-network-api-reference"
    }}>{`Edge Network API reference`}</h1>
    <h2 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h2>
    <p>{`Returns the version of the client-side Edge extension.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=extension-version" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=extension-version" mdxType="Tabs" />
    <h2 {...{
      "id": "getlocationhint"
    }}>{`getLocationHint`}</h2>
    <p>{`Gets the Edge Network location hint used in requests to the Adobe Experience Platform Edge Network. The Edge Network location hint may be used when building the URL for Adobe Experience Platform Edge Network requests to hint at the server cluster to use.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=get-location-hint" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=get-location-hint" mdxType="Tabs" />
    <h2 {...{
      "id": "registerextension"
    }}>{`registerExtension`}</h2>
    <Alerts query="platform=android-register-extension&componentClass=InlineNestedAlert" mdxType="Alerts" />
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=register-extension" mdxType="Tabs" />
    <h2 {...{
      "id": "resetidentities"
    }}>{`resetIdentities`}</h2>
    <p>{`Resets current state of the AEP Edge extension and clears previously cached content related to current identity, if any.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "../../home/base/mobile-core/api-reference.md#resetidentities"
      }}>{`MobileCore.resetIdentities`}</a>{` for more details.`}</p>
    <h2 {...{
      "id": "sendevent"
    }}>{`sendEvent`}</h2>
    <p>{`Sends an Experience event to Adobe Experience Platform Edge Network.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Starting with `}<inlineCode parentName="p">{`Edge`}</inlineCode>{` extension version `}<strong parentName="p">{`2.4.0`}</strong>{` (Android) and `}<strong parentName="p">{`4.3.0`}</strong>{` (iOS), the `}<inlineCode parentName="p">{`sendEvent`}</inlineCode>{` API supports optional datastream overrides. This allows you to adjust your datastreams without the need for new ones or modifications to existing settings.`}</p>
    <p>{`The process involves two steps:`}</p>
    <ol>
      <li parentName="ol">{`Define your Datastream configuration overrides on the `}<a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/experience-platform/datastreams/configure.html"
        }}>{`datastream configuration page`}</a>{`.`}</li>
      <li parentName="ol">{`Send these overrides to the Edge Network using the `}<inlineCode parentName="li">{`sendEvent`}</inlineCode>{` API.`}</li>
    </ol>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=send-event" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=send-event" mdxType="Tabs" />
    <h2 {...{
      "id": "setlocationhint"
    }}>{`setLocationHint`}</h2>
    <p>{`Sets the Edge Network location hint used in requests to the Adobe Experience Platform Edge Network. Passing nil or an empty string clears the existing location hint. Edge Network responses may overwrite the location hint to a new value when necessary to manage network traffic.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`Use caution when setting the location hint. Only use location hints for the "EdgeNetwork" scope. An incorrect location hint value will cause all Edge Network requests to fail with 404 response code.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=set-location-hint" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=set-location-hint" mdxType="Tabs" />
    <h2 {...{
      "id": "public-classes"
    }}>{`Public classes`}</h2>
    <h3 {...{
      "id": "xdm-schema"
    }}>{`XDM Schema`}</h3>
    <p>{`The AEP Edge extension provides the Schema and Property interfaces (Android) / XDMSchema protocol (iOS) that can be used to define the classes associated with your XDM schema in Adobe Experience Platform.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=xdm-schema" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=xdm-schema" mdxType="Tabs" />
    <h3 {...{
      "id": "edgeeventhandle"
    }}>{`EdgeEventHandle`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`EdgeEventHandle`}</inlineCode>{` is a response fragment from Adobe Experience Platform Edge Network for a sent XDM Experience Event.
One event can receive none, one or multiple `}<inlineCode parentName="p">{`EdgeEventHandle`}</inlineCode>{`(s) as response.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=edge-event-handle" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=edge-event-handle" mdxType="Tabs" />
    <p>{`Use this class when calling the `}<a parentName="p" {...{
        "href": "#sendevent"
      }}>{`sendEvent`}</a>{` API with EdgeCallback.`}</p>
    <h3 {...{
      "id": "experienceevent"
    }}>{`ExperienceEvent`}</h3>
    <p>{`Experience Event is the event to be sent to Adobe Experience Platform Edge Network.
The XDM data is required for any Experience Event being sent using the Edge extension.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=experience-event" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=experience-event" mdxType="Tabs" />
    <p>{`See `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-edge-ios/blob/main/Documentation/extension-usage.md"
      }}>{`Edge Extension Usage`}</a>{` for more examples.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      